export default "__VITE_ASSET__CWCAxyGL__"